import { useState } from 'react';
import { isAdmin } from '../lib/constants.js';
import UsersPanel from './admin/UsersPanel.jsx';
import SettingsPanel from './admin/SettingsPanel.jsx';
import DisplayLinksPanel from './admin/DisplayLinksPanel.jsx';
import ChangePasswordPanel from './admin/ChangePasswordPanel.jsx';

const TABS = [
  { id: 'users', label: 'الحسابات' },
  { id: 'display', label: 'شاشات العرض' },
  { id: 'settings', label: 'الإعدادات والطباعة' },
  { id: 'password', label: 'كلمة المرور' },
];

export default function Admin({
  user,
  settings,
  hasLetterhead,
  letterheadSource,
  onSettingsChanged,
  showToast,
}) {
  const [tab, setTab] = useState('users');

  // The route is only reachable from an admin-only control, but a non-admin
  // typing the URL must not see the page either. The server enforces this
  // independently on every admin endpoint.
  if (!isAdmin(user)) {
    return (
      <div className="empty-state">
        <h3>لا تملك صلاحية الوصول إلى هذه الصفحة</h3>
        <p>هذه الصفحة مخصّصة لمدير النظام.</p>
      </div>
    );
  }

  return (
    <div className="admin-page">
      <div className="tabs" role="tablist">
        {TABS.map((entry) => (
          <button
            key={entry.id}
            type="button"
            role="tab"
            aria-selected={tab === entry.id}
            className={`tab${tab === entry.id ? ' is-active' : ''}`}
            onClick={() => setTab(entry.id)}
          >
            {entry.label}
          </button>
        ))}
      </div>

      {tab === 'users' && <UsersPanel currentUser={user} showToast={showToast} />}

      {tab === 'display' && <DisplayLinksPanel showToast={showToast} />}

      {tab === 'settings' && (
        <SettingsPanel
          settings={settings}
          hasLetterhead={hasLetterhead}
          letterheadSource={letterheadSource}
          onSettingsChanged={onSettingsChanged}
          showToast={showToast}
        />
      )}

      {tab === 'password' && <ChangePasswordPanel showToast={showToast} />}
    </div>
  );
}
